import './App.css';
import { lazy, Suspense, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import EnquiryModal from './components/EnquiryModal';
import HomePage from './pages/HomePage';

// Import all CSS files globally to prevent lazy loading issues
import './styles/ServicesPage.css';
import './pages/styles/IndustriesPage.css';
import './pages/styles/IndustryPage.css';
import './pages/styles/InsightsPage.css';
import './pages/styles/CaseStudiesPage.css';
import './pages/styles/CaseStudyDetailPage.css';
import './pages/styles/WhitePaperPage.css';
import './pages/styles/NotFoundPage.css';

const ServicesPage = lazy(() => import('./pages/ServicesPage'));
const ServiceCategoryPage = lazy(() => import('./pages/ServiceCategoryPage'));
const IndustriesPage = lazy(() => import('./pages/industries/IndustriesPage'));
const IndustryPage = lazy(() => import('./pages/industries/IndustryPage'));
const InsightsPage = lazy(() => import('./pages/insights/InsightsPage'));
const CaseStudiesPage = lazy(() => import('./pages/insights/CaseStudiesPage'));
const CaseStudyDetailPage = lazy(() => import('./pages/insights/CaseStudyDetailPage'));
const BlogPage = lazy(() => import('./pages/insights/BlogPage'));
const UseCasesPage = lazy(() => import('./pages/insights/UseCasesPage'));
const WhitePaperPage = lazy(() => import('./pages/insights/WhitePaperPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const ProcessPage = lazy(() => import('./pages/ProcessPage'));
const CareersPage = lazy(() => import('./pages/CareersPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const TermsPage = lazy(() => import('./pages/TermsPage'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

function PageLoader() {
  return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Loading...</div>;
}

export const EnquiryContext = require('react').createContext();

function App() {
  const [enquiryModal, setEnquiryModal] = useState({
    isOpen: false,
    source: 'Website',
  });

  const openEnquiryModal = (source = 'Website') => {
    setEnquiryModal({
      isOpen: true,
      source: source,
    });
  };

  const closeEnquiryModal = () => {
    setEnquiryModal({
      isOpen: false,
      source: 'Website',
    });
  };

  return (
    <>
      <Routes>
        <Route element={<Layout openEnquiry={openEnquiryModal} />}>
          <Route index element={<HomePage openEnquiry={openEnquiryModal} />} />
          <Route path="services" element={<Suspense fallback={<PageLoader />}><ServicesPage openEnquiry={openEnquiryModal} /></Suspense>} />
          <Route path="services/:category" element={<Suspense fallback={<PageLoader />}><ServiceCategoryPage openEnquiry={openEnquiryModal} /></Suspense>} />
          <Route path="industries" element={<Suspense fallback={<PageLoader />}><IndustriesPage /></Suspense>} />
          <Route path="industries/:slug" element={<Suspense fallback={<PageLoader />}><IndustryPage /></Suspense>} />
          <Route path="insights" element={<Suspense fallback={<PageLoader />}><InsightsPage /></Suspense>} />
          <Route path="insights/case-studies" element={<Suspense fallback={<PageLoader />}><CaseStudiesPage /></Suspense>} />
          <Route path="insights/case-studies/:id" element={<Suspense fallback={<PageLoader />}><CaseStudyDetailPage openEnquiry={openEnquiryModal} /></Suspense>} />
          <Route path="insights/blog" element={<Suspense fallback={<PageLoader />}><BlogPage /></Suspense>} />
          <Route path="insights/use-cases" element={<Suspense fallback={<PageLoader />}><UseCasesPage /></Suspense>} />
          <Route path="insights/white-paper" element={<Suspense fallback={<PageLoader />}><WhitePaperPage /></Suspense>} />
          <Route path="about" element={<Suspense fallback={<PageLoader />}><AboutPage openEnquiry={openEnquiryModal} /></Suspense>} />
          <Route path="process" element={<Suspense fallback={<PageLoader />}><ProcessPage openEnquiry={openEnquiryModal} /></Suspense>} />
          <Route path="careers" element={<Suspense fallback={<PageLoader />}><CareersPage openEnquiry={openEnquiryModal} /></Suspense>} />
          <Route path="contact" element={<Suspense fallback={<PageLoader />}><ContactPage /></Suspense>} />
          <Route path="terms" element={<Suspense fallback={<PageLoader />}><TermsPage /></Suspense>} />
          <Route path="privacy" element={<Suspense fallback={<PageLoader />}><PrivacyPage /></Suspense>} />

          <Route path="*" element={<Suspense fallback={<PageLoader />}><NotFoundPage openEnquiry={openEnquiryModal} /></Suspense>} />
        </Route>
      </Routes>

      <EnquiryModal
        isOpen={enquiryModal.isOpen}
        onClose={closeEnquiryModal}
        source={enquiryModal.source}
      />
    </>
  );
}

export default App;
